<modal-component [fullWidth]="true">
	<!-- LEFT-->
	<ng-container left>

		<ng-container *ngIf="!showConfirmation">
			<div class="_header">
				<p class="_title" [translate]="'BEEGO_APPOINTMENT.TITLE'"></p>
				<div class="_beego">
					<img class="_logo" src="./assets/BEEGO_logo.png" />
					<p [translate]="'BEEGO_APPOINTMENT.SUBTITLE'"></p>
				</div>
			</div>

			<div class="_info _actionable" *ngIf="countDown" [ngClass]="{'_error': calendarEventNoLongerReserved}">
				<info-line icon="./assets/icons/time-outline.svg"  align="top">
					<p *ngIf="!calendarEventNoLongerReserved; else noLongerReserved" [translate]="'BEEGO_APPOINTMENT.CALENDAR_EVENT_RESERVED'" [translateParams]="{countDown}">	
					</p>
					<ng-template #noLongerReserved>
						<p>
							{{"BEEGO_APPOINTMENT.CALENDAR_EVENT_NO_LONGER_RESERVED" | translate}}
						</p>
					</ng-template>
				</info-line>
			</div>
	
			<div class="_info">
				<info-line icon="./assets/icons/calendar-outline.svg" align="top">
					<p>{{calendarEvent.startsAt | date:'EEEE d MMM yyyy'}}</p>
				</info-line>
				
				<info-line icon="./assets/icons/time-outline.svg"  align="top">
					<p>{{'BEEGO_APPOINTMENT.TIME_INFO_START' | translate }} 
						<b>{{calendarEvent.startsAt | date:"HH:mm"}}</b> 
						{{ 'BEEGO_APPOINTMENT.TIME_INFO_AND' | translate }} 
						<b>{{appointmentBufferEnd | date:"HH:mm"}}</b>
						{{'BEEGO_APPOINTMENT.TIME_INFO_END' | translate }}
					</p>
				</info-line>			
				
				<info-line icon="./assets/icons/absent-outline.svg" align="top" >
					<p [innerHTML]="'BEEGO_APPOINTMENT.CANCEL_INFO' | translate"></p>
				</info-line>
				
				<info-line icon="./assets/icons/euro-outline.svg" align="top" >
					<p><b [translate]="'BEEGO_APPOINTMENT.PAYMENT_INFO_TITLE'"></b></p>
					<p [translate]="'BEEGO_APPOINTMENT.PAYMENT_INFO'"></p>
				</info-line>

				<info-line icon="./assets/icons/student-outline.svg" align="top" >
					<p><b [translate]="'BEEGO_APPOINTMENT.STUDENT'"></b></p>
					<p>{{calendarEvent.BeecloudCalendarEvent.WorkBlock.Employee.firstname}}</p>
				</info-line>
					
				<div class="_picture-container">
					<img class="_student" [src]="calendarEvent.BeecloudCalendarEvent.WorkBlock.Employee.pictureUrl">
				</div>
	
			</div>
		</ng-container>

		<ng-container *ngIf="showConfirmation">
			<div class="_header">
				<p class="_title" [translate]="'BEEGO_APPOINTMENT.COMPLETED'"></p>
			</div>

			<div class="_confirmation-info">
				<p [translate]="'PRINT_INFO'"></p>
			</div>
		</ng-container>

		
	</ng-container>	

	<!-- RIGHT -->
	<ng-container right>

		<ng-container *ngIf="!showConfirmation">
			<form [formGroup]="appointmentForm">
				<form-client [formGroup]="appointmentForm.get('Client') | cast" [isBeegoAppointment]="true"></form-client>

				<p class="_title">{{'TEMPLATE_VARIABLES.QUESTION_TITLE' | translate}}</p>

				<form-select 
					label="{{ 'RESERVATION.QUESTION_CATEGORY' | translate }}" 
					[formControl]="appointmentForm.get('Attendance.QuestionCategories') | cast" 
					[items]="questionCategories" 
					bindValue="id" 
					bindLabel="name" 
					[multiple]="true" 
					position="top">
					<button *ifUserHasPermissions="[UserPermissions.WriteConfigurations]" add-button class="_button _add-button" (click)="createQuestionCategory()">
						<ion-icon src="./assets/icons/add-outline.svg"></ion-icon>
					</button>
				</form-select>				

				<form-textarea label="{{ 'BEEGO_APPOINTMENT.QUESTION' | translate }}" [formControl]="appointmentForm.get('question') | cast"></form-textarea>

				<form-select label="{{ 'EVENT.DIGIBANK_OBJECTIVE.TITLE' | translate }}" [formControl]="appointmentForm.get('digibankObjective') | cast" [items]="digibankObjectives" bindValue="value" bindLabel="label" [multiple]="false">

				</form-select>			

				<client-digicheques-count-component [clientId]="appointmentForm.get('Client.id').value"></client-digicheques-count-component>
	
				<div class="_digicheques-container">
					<p class="_digicheque-title" [translate]="'BEEGO_APPOINTMENT.DIGICHEQUE'"></p>
	
					<div class="_digicheque-container">
						<div class="_digicheque" *ngFor="let digicheque of appointmentForm.get('Digicheques').value">
							<div>
								<p class="_name">{{digicheque.Discount.name}}</p>
								<p class="_discount-code">{{digicheque.code}} <span *ngIf="digicheque.expiresOn">- {{digicheque.expiresOn | date:'dd/MM/yy'}}</span></p>
								<p class="_pricing">&euro;{{digicheque.Discount.amount}}: <span [translate]="'BEEGO_APPOINTMENT.DIGICHEQUE_PRICE'"></span></p>
							</div>
							<ion-icon (click)="onRemoveDiscountCode(digicheque)" name="trash-outline"></ion-icon>
						</div>
	
						<div class="_add-digicheque" (click)="onAddDiscountCode()">
							<ion-icon src="./assets/icons/add-outline.svg"></ion-icon>
							<p [translate]="'BEEGO_APPOINTMENT.ADD_DIGICHEQUE'"></p>
						</div>
					</div>
				</div>

				<ng-container *ngIf="communication">
					<p class="_title">{{'COMMUNICATION.TITLE_SHORT' | translate}}</p>
					<form-communication-component [replyTo]="appointmentForm.get('replyTo') | cast" [telephone]="appointmentForm.get('telephone') | cast" [communication]="communication"></form-communication-component>
				</ng-container>
			</form>	
		</ng-container>

		<div class="_confirmation" *ngIf="showConfirmation">
			<p [translate]="'BEEGO_APPOINTMENT.TITLE'"></p>
			<info-line icon="./assets/icons/calendar-outline.svg" align="top">
				<p>{{calendarEvent.startsAt | date:'E dd/MM/yyyy'}}</p>
			</info-line>
			
			<info-line icon="./assets/icons/time-outline.svg">
				<p>{{calendarEvent.startsAt | date:"HH:mm"}} - {{calendarEvent.endsAt | date:"HH:mm"}}</p>
			</info-line>	
			
			<info-line icon="./assets/icons/student-outline.svg" align="top" >
				<p [translate]="'BEEGO_APPOINTMENT.STUDENT'"></p>
				<p>{{calendarEvent.BeecloudCalendarEvent.WorkBlock.Employee.firstname}}</p>
			</info-line>		

			<p [translate]="'RESERVATION.CONTACT'"></p>
			<p class="_confirmation-subtitle" [translate]="'RESERVATION.CONTACT_INFO'"></p>

			<info-line icon="./assets/icons/user-outline.svg">
				<p>{{beegoAppointment.CreatedBy.Employee.firstname}} {{beegoAppointment.CreatedBy.Employee.lastname}}</p>
			</info-line>

			<info-line icon="./assets/icons/email-outline.svg">
				<p>{{beegoAppointment.CreatedBy.email}}</p>
			</info-line>

			<p [translate]="'RESERVATION.PARTICIPANT_DATA'"></p>
			<info-line icon="./assets/icons/user-outline.svg">
				<p>
					<span [navigate]="[InternalNavigationType.page, '/internal/clienten/client', [NavigationDataKey.client, appointmentForm.get('Client').value]]">{{appointmentForm.get('Client').value.firstname}} {{appointmentForm.get('Client').value.lastname}}</span>
				</p>
			</info-line>

			<info-line icon="./assets/icons/location-outline.svg">
				<p [navigate]="[InternalNavigationType.address, appointmentForm.get('Client.Address').value]">{{appointmentForm.get('Client.Address').value | address}}</p>
			</info-line>
		
			<info-line icon="./assets/icons/phone-outline.svg">
				<p [navigate]="[InternalNavigationType.phone, appointmentForm.get('Client.telephone').value]">{{appointmentForm.get('Client.telephone').value}}</p>
			</info-line>
		
			<info-line icon="./assets/icons/email-outline.svg">
				<p [navigate]="[InternalNavigationType.email, appointmentForm.get('Client.email').value]">{{appointmentForm.get('Client.email').value}}</p>
			</info-line>
		</div>


		
	</ng-container>

	<!-- BUTTONS -->
	<ng-container buttons>
		<ng-container *ngIf="!showConfirmation">
			<button class="_button _create-button" [translate]="'BEEGO_APPOINTMENT.CREATE'" (click)="createAppointment()"></button>	
			<button class="_button _cancel-button" [translate]="'CONTINUE'" (click)="close()"></button>
		</ng-container>
		<ng-container *ngIf="showConfirmation">
			<button class="_button _print-button" (click)="print()">
				<ion-icon src="./assets/icons/print-outline.svg"></ion-icon>
				<span [translate]="'PRINT'"></span>
			</button>
			<button class="_button _cancel-button" [translate]="'CONTINUE'" (click)="close()"></button>
		</ng-container>
		
	</ng-container>

</modal-component>
